<template>
  <div ph-autocapture>
    <Header></Header>
    <slot />
    <Footer></Footer>
    <CookieNotification></CookieNotification>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRuntimeConfig, useHead, useNuxtApp } from '#imports'
import Header from '@saas/components/Header'
import Footer from '@saas/components/Footer'
import CookieNotification from '@saas/components/CookieNotification'

const route = useRoute()
const config = useRuntimeConfig()
const { $store } = useNuxtApp()

const navOpen = computed(() => {
  if (!$store || !$store.hasModule('header')) {
    return false
  }
  return $store.getters['header/getNavOpen']
})

useHead(
  computed(() => ({
    titleTemplate: '',
    htmlAttrs: {
      lang: 'en',
    },
    bodyAttrs: {
      class: ['saas-page', navOpen.value ? 'saas-menu--open' : ''],
    },
    link: [
      {
        hid: 'canonical',
        rel: 'canonical',
        // By default, strip all the query parameters because they render the same
        // page, and cause duplicates.
        href: config.public.publicWebFrontendUrl + route.path,
      },
    ],
  }))
)
</script>
